import * as React from 'react';
import ContentLoading from 'Components/ContentLoading';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
// import { useParams } from "react-router-dom";
import PhoneInputField from '../../../../Components/PhoneInputField';
import { TextField, Button, Chip, CircularProgress /* , Switch */ } from '@material-ui/core';
import AppLoader from '../../../../Components/AppLoader';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OutlinedSelect from '../../../../Components/OutlinedSelect';
import { checkValidEmail, notify } from '../../../../utils';
import {
    CUSTOMER_FIELDS,
    apiFieldErrors,
    fieldLabel,
    scrollToFirstError,
    summariseErrors,
    validateCustomer,
} from './customerSchema';
import SectorField from './SectorField';
import AddressAutocomplete from '../../../../Components/AddressAutocomplete';
import { timezone } from '../../../../Assets/timeZone';
import { accountList, useStyles, initCustomerFormState } from '../../../SuperAdmin/Customers/Create';
import { useStyle as onboardingStyle } from '../../../CustomerOnBoarding';
import { CustomerServices } from '../../../../Services/CustomerServices';
import { useParams } from 'react-router';
import SendTestEmailModal from '../../../../Components/SendTestEmailModal';
import variables from '../../../../Sys/variable.scss';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Pagination } from '@material-ui/lab';
import SearchBoxInput from '../../../../Components/SearchBoxInput';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { customerProvinces, provinceOptions, withCurrentOptions, normalizeToOption } from '../../../../utils/locationOptions';

const customerServices = new CustomerServices();
const initFormState = {
    ...initCustomerFormState,
    sector: '',
    province: '',
    provinces: [],
    email_host: '',
    port: '22',
    from: '',
    email_host_user: '',
    email_host_password: '',
    email_subject_prifix: '',
    recipients: '',
    secure_connection: false,
    use_authentication: false
    /* , talent_access: false */
};

const useCustomerStyles = makeStyles((theme) => ({
    section: {
        paddingBottom: theme.spacing(2.5),
    },
    sectionDivider: {
        marginTop: theme.spacing(1),
        paddingTop: theme.spacing(3),
        borderTop: '1px solid #e7ebf0',
    },
    sectionHeader: {
        marginBottom: theme.spacing(2.5),
    },
    sectionTitle: {
        color: '#27364a',
        fontSize: '0.9375rem',
        fontWeight: 700,
        lineHeight: 1.4,
        marginBottom: theme.spacing(0.5),
    },
    sectionDescription: {
        color: '#748195',
        fontSize: '0.75rem',
        lineHeight: 1.55,
        maxWidth: 680,
    },
    formFields: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            backgroundColor: '#ffffff',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d6dde6',
        },
        '& .MuiFormLabel-root': {
            color: '#667487',
        },
    },
    logoField: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        minHeight: 40,
    },
    logoLabel: {
        color: '#556476',
        fontSize: '0.75rem',
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    logoActions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        flexWrap: 'wrap',
    },
    uploadButton: {
        borderColor: '#c9d4e1',
        color: '#345474',
        borderRadius: 4,
        textTransform: 'none',
        padding: theme.spacing(0.75, 1.5),
    },
    uploadHint: {
        color: '#7b8796',
        fontSize: '0.6875rem',
    },
    logoPreview: {
        width: 72,
        height: 72,
        objectFit: 'contain',
        padding: theme.spacing(0.75),
        border: '1px solid #dbe2ea',
        borderRadius: 4,
        backgroundColor: '#ffffff',
    },
    actionBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
        paddingTop: theme.spacing(2.5),
        borderTop: '1px solid #e7ebf0',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            '& .MuiButton-root': {
                minWidth: 0,
                paddingLeft: 12,
                paddingRight: 12,
            },
        },
    },
    actionButtons: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        marginLeft: 'auto',
        flexWrap: 'nowrap',
    },
    cancelAction: {
        minWidth: 150,
    },
    continueAction: {
        minWidth: 190,
        borderRadius: 4,
        textTransform: 'none',
        padding: theme.spacing(1, 2),
        boxShadow: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    logoTalentRow: {
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        '@media (max-width:1280px) and (min-width:1215px)': {
            alignItems: 'flex-start',
            gap: theme.spacing(1.5),
        },
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            '& > div:first-of-type': { marginBottom: theme.spacing(1) },
            '& .MuiFormControlLabel-root': { marginLeft: 0, marginTop: theme.spacing(2) },
            '& .MuiButton-root': { marginLeft: 0, marginTop: theme.spacing(2), minWidth: '100%', maxWidth: '100%' },
        },
    },
    logoUploadWrap: {
        flex: '1 1 260px',
        minWidth: 240,
        '@media (max-width:1280px) and (min-width:1215px)': {
            flexBasis: '100%',
            minWidth: '100%',
        },
    },
    talentToggle: {
        marginLeft: 0,
        marginTop: 0,
        alignSelf: 'flex-end',
        '& .MuiFormControlLabel-label': {
            whiteSpace: 'nowrap',
        },
    },
    fetchButton: {
        whiteSpace: 'nowrap',
        minWidth: 260,
        maxWidth: 320,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        borderRadius: '5px',
        padding: '10px 20px 10px',
        marginLeft: 0,
        marginTop: 0,
        alignSelf: 'flex-end',
    },
    sectionLoaderWrap: {
        minHeight: 280,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tableContainer: {
        borderRadius: 12,
        border: '1px solid var(--dm-border, #e7ebf0)',
        overflowX: 'auto',
        boxShadow: 'none',
    },
    headerCell: {
        color: 'var(--dm-text-strong, #263548)',
        backgroundColor: 'var(--dm-row-alt, #f8fafc)',
        fontWeight: 700,
        fontSize: '0.78rem',
        padding: '13px 16px',
        whiteSpace: 'nowrap',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        borderBottom: '1px solid var(--dm-border, #e7ebf0)',
    },
    bodyRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'rgba(0,0,0,0.025)',
        },
        '&:nth-of-type(even)': {
            backgroundColor: 'transparent',
        },
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.055) !important',
        },
        transition: 'background-color 0.15s ease',
    },
    bodyCell: {
        color: variables.darkThemeText,
        padding: '11px 16px',
        fontSize: '0.875rem',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
    },
    tableLoadingCell: {
        padding: '28px 16px',
        textAlign: 'center',
    },
    dialogActions: {
        padding: theme.spacing(2, 3),
    },
    dialogActionButtons: {
        width: '100%',
        justifyContent: 'flex-end',
        '& .MuiButton-root': {
            marginTop: 0,
            marginLeft: 0,
        },
    },
}));

const Customer = ({
    activeStep,
    countryList,
    handleBack,
    handleNext,
    handleCancel,
    formBackupState,
    handleUpdateBackupFormData,
    talentDialogOpen,
    setTalentDialogOpen
}) => {

    const classes = useStyles();
    const customerClasses = useCustomerStyles();
    const onBorningClasses = onboardingStyle();
    const { id } = useParams();
    const [showSMTP, setShowSMTP] = React.useState(false);
    const [submitLoading, setSubmitLoading] = React.useState(false);
    const [formState, setFormState] = React.useState({ ...initFormState });
    const [fieldErrors, setFieldErrors] = React.useState({});
    const [sendTestMailOpen, setSendTestMailOpen] = React.useState(false);
    const [sendTestEmailLoading, setSendTestEmailLoading] = React.useState(false);
    const [initialLoading, setInitialLoading] = React.useState(!!id);
    // const [talentToggleSaving, setTalentToggleSaving] = React.useState(false);

    // New state for dialog and users/courses data
    const [talentUsers, setTalentUsers] = React.useState([]);
    const [talentLoading, setTalentLoading] = React.useState(false);
    const [notifyLoading, setNotifyLoading] = React.useState(false);
    const [talentFilterState, setTalentFilterState] = React.useState({ page: 1, search: '' });
    const [talentPagination, setTalentPagination] = React.useState(null);
    const skipTalentSearchEffectRef = React.useRef(false);
    const talentSearchTimer = React.useRef(null);
    const isPartialEmailSearch = React.useMemo(() => {
        const searchText = (talentFilterState.search || '').trim();
        return searchText.includes('@') && !checkValidEmail(searchText);
    }, [talentFilterState.search]);

    const getCustomerDetail = React.useCallback(async () => {
        const csDetails = await customerServices.getCustomerDetail(id);
        if (csDetails && csDetails.data && csDetails.data.length) {
            let reponseData = csDetails.data[0];
            let domain = reponseData.domain;
            domain = domain ? domain.split('.')[0] : '';
            setFormState({
                email: reponseData.email,
                contact_no: reponseData.contact_no
                    ? `+${reponseData.contact_no.toString()}`
                    : '',
                name: reponseData.name,
                sector: reponseData.sector || '',
                province: customerProvinces(reponseData)[0] || '',
                provinces: customerProvinces(reponseData),
                address: reponseData.address,
                country: reponseData.country,
                domain: domain,
                partner: reponseData.partner,
                branch: reponseData.branch || '',
                link: reponseData.link || '',
                api_key: reponseData.api_key || '',
                timezone: timezone.find(option => option.name === reponseData.timezone) || '',
                email_host: reponseData.email_host || '',
                email_host_password: reponseData.email_host_password || '',
                email_host_user: reponseData.email_host_user || '',
                email_subject_prifix: reponseData.email_subject_prifix || '',
                from: reponseData.from || '',
                logo: reponseData.logo,
                port: reponseData.port || '22',
                secure_connection: !!reponseData.secure_connection,
                use_authentication: !!reponseData.use_authentication,
                // talent_access: reponseData.talent_access || false,
            });
            setShowSMTP(reponseData.email_host ? true : false);
            localStorage.setItem('cstmsrSaveFlow', id);
            localStorage.setItem('customerUUID', id);
        }
    }, [id]);

    React.useEffect(() => {
        const loadCustomerData = async () => {
            if (formBackupState) {
                setFormState({ ...formBackupState });
            }
            if (!id) {
                setInitialLoading(false);
                return;
            }
            try {
                await getCustomerDetail();
            } finally {
                setInitialLoading(false);
            }
        };
        loadCustomerData();
    }, [formBackupState, id, getCustomerDetail]);

    const clearFieldError = (name) => {
        setFieldErrors(prev => {
            if (!prev[name]) return prev;
            const next = { ...prev };
            delete next[name];
            return next;
        });
    };

    const handleInputChange = (e, field) => {
        if (field) {
            clearFieldError(field);
            setFormState({ ...formState, [field]: e });
        } else {
            const { name, value } = e.target;
            clearFieldError(name);
            setFormState({ ...formState, [name]: value });
        }
    }

    const handleCountryChange = (newValue) => {
        clearFieldError('country');
        const sameCountry = newValue === formState.country;
        setFormState({
            ...formState,
            country: newValue || '',
            province: sameCountry ? formState.province : '',
            provinces: sameCountry ? customerProvinces(formState) : [],
        });
    };

    /** Fills country and province from the chosen address only where they are still empty. */
    const handlePlaceSelected = (place) => {
        setFormState(prev => {
            const next = { ...prev, address: place.address || prev.address };
            if (!prev.country && place.country) next.country = place.country;
            if (!customerProvinces(prev).length && place.province) {
                next.provinces = [place.province];
                next.province = place.province;
            }
            return next;
        });
    };

    const handleProvincesChange = (values) => {
        clearFieldError('province');
        const provinces = [...new Set((values || []).map(value => String(value || '').trim()).filter(Boolean))];
        setFormState({ ...formState, provinces, province: provinces[0] || '' });
    };

    const handleChangeSMTP = (evt) => {
        setShowSMTP(evt.target.checked);
    }

    const formValidationCheck = (evt) => {
        const fields = id ? Object.keys(CUSTOMER_FIELDS).filter(key => key !== 'email') : Object.keys(CUSTOMER_FIELDS);
        const errors = validateCustomer(formState, { fields });
        setFieldErrors(errors);
        if (Object.keys(errors).length) {
            notify('error', summariseErrors(errors));
            scrollToFirstError();
            return null;
        }
        return handleFormSubmit(evt);
    }

    const errorProps = name => ({
        error: !!fieldErrors[name],
        helperText: fieldErrors[name] || undefined,
    });

    const buildCustomerPayload = (state) => {
        let payload = { ...state };
        // Talent Platform Access toggle disabled — omit from customer API until re-enabled
        delete payload.talent_access;
        let editstep = localStorage.getItem('editstep');
        let customer_id = null;
        if (editstep === '0' || id) {
            customer_id = localStorage.getItem('customerUUID') || id;
            if (payload.domain) {
                payload.domain = (payload.partner === 'reseller_partner') ? state.domain + '.partner.deviare.co.za' : state.domain + '.platform.digitalskillsonline.net';
            } else {
                payload.domain = '';
            }
        } else {
            payload.domain = (payload.partner === 'reseller_partner') ? state.domain + '.partner.deviare.co.za' : state.domain + '.platform.digitalskillsonline.net';
        }

        payload.timezone = payload?.timezone?.name || '';
        payload.link = payload?.link || '';
        payload.api_key = payload?.api_key || '';
        return { payload, customer_id };
    };

    const handleFormSubmit = async (evt) => {
        setSubmitLoading(true);
        const { payload, customer_id } = buildCustomerPayload(formState);
        try {
            const result = await customerServices.addCustomer(payload, customer_id);
            if (result && result.status) {
                localStorage.setItem('cstmsrSaveFlow', result.data.uuid);
                localStorage.setItem('customerUUID', result.data.uuid);
                localStorage.setItem('getAllCustomer', true);
                handleNext();
                handleUpdateBackupFormData({ ...formState }, 'customer');
                notify("success", result.message);
            } else {
                setSubmitLoading(false);
                const serverErrors = apiFieldErrors(result);
                if (Object.keys(serverErrors).length) {
                    setFieldErrors(serverErrors);
                    scrollToFirstError();
                }
                notify("error", (result && result.message) ? result.message : summariseErrors(serverErrors) || 'Something Went Wrong');
            }
        } catch (e) {
            setSubmitLoading(false);
            notify("error", (e && e.message) ? e.message : 'Something Went Wrong');
        }
    }

    const handleUploadImage = (e) => {
        let file = e.target.files[0];
        if (!file) return;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            handleInputChange(reader.result, 'logo');
        };
    };

    const handleChangeCheckItem = (name) => {
        handleInputChange(!formState[name], name);
    }

    const handleSendEmailSubmit = async (recipients) => {
        setSendTestEmailLoading(true);
        let sendEmailData = { ...formState };
        let data = {
            email_host: sendEmailData.email_host,
            email_subject_prifix: sendEmailData.email_subject_prifix,
            email_host_user: sendEmailData.email_host_user,
            email_host_password: sendEmailData.email_host_password,
            recipients: recipients
        };
        const emailRes = await customerServices.sendTestEmail(data);
        if (emailRes && emailRes.status) {
            notify('success', emailRes?.message || "Email send successfully");
        } else {
            notify("error", (emailRes && emailRes.message) ? emailRes.message : 'Something Went Wrong');
        }
        setSendTestMailOpen(false);
        setSendTestEmailLoading(false);
    }

    // Talent Platform Access toggle — restore when re-enabling UI below
    // const handleToggleTalentAccess = async (event) => {
    //     const newChecked = event.target.checked;
    //     const previousState = formState;
    //     const nextState = { ...formState, talent_access: newChecked };
    //     setFormState(nextState);
    //
    //     const customer_id = localStorage.getItem('customerUUID') || id;
    //     if (!customer_id) {
    //         return;
    //     }
    //
    //     setTalentToggleSaving(true);
    //     const { payload, customer_id: resolvedId } = buildCustomerPayload(nextState);
    //     try {
    //         const result = await customerServices.addCustomer(payload, resolvedId);
    //         if (result && result.status) {
    //             if (result.data?.uuid) {
    //                 localStorage.setItem('cstmsrSaveFlow', result.data.uuid);
    //                 localStorage.setItem('customerUUID', result.data.uuid);
    //             }
    //             localStorage.setItem('getAllCustomer', true);
    //             handleUpdateBackupFormData({ ...nextState }, 'customer');
    //             notify('success', result.message);
    //         } else {
    //             setFormState(previousState);
    //             notify('error', (result && result.message) ? result.message : 'Something Went Wrong');
    //         }
    //     } catch (e) {
    //         setFormState(previousState);
    //         notify('error', (e && e.message) ? e.message : 'Something Went Wrong');
    //     }
    //     setTalentToggleSaving(false);
    // };

    const fetchTalentUsers = React.useCallback(async (queryData, openDialog = false) => {
        setTalentLoading(true);
        try {
            const response = await customerServices.getTalentPlatformUsersWithCourses(id, queryData);
            if (response && response.status && Array.isArray(response.data?.users)) {
                setTalentUsers(response.data.users);
                setTalentPagination(response.data?.pagination || response?.pagination || null);
                if (openDialog) {
                    setTalentDialogOpen(true);
                }
            } else {
                setTalentUsers([]);
                notify('error', response?.message || 'Failed to fetch users');
            }
        } catch (error) {
            setTalentUsers([]);
            notify('error', error?.message || 'Failed to fetch users');
        }
        setTalentLoading(false);
    }, [id, setTalentDialogOpen]);

    const handleTalentPageChange = (evt, page) => {
        clearTimeout(talentSearchTimer.current);
        if (isPartialEmailSearch) return;
        const updatedFilterState = { ...talentFilterState, page };
        setTalentFilterState(updatedFilterState);
        fetchTalentUsers(updatedFilterState);
    };

    const handleTalentSearch = (evt) => {
        clearTimeout(talentSearchTimer.current);
        if (evt && evt.preventDefault) evt.preventDefault();
        if (isPartialEmailSearch) return;
        const updatedFilterState = { ...talentFilterState, page: 1 };
        setTalentFilterState(updatedFilterState);
        fetchTalentUsers(updatedFilterState);
    };

    React.useEffect(() => {
        if (!talentDialogOpen) return;
        if (skipTalentSearchEffectRef.current) {
            skipTalentSearchEffectRef.current = false;
            return;
        }
        if (isPartialEmailSearch) return;
        talentSearchTimer.current = setTimeout(() => {
            fetchTalentUsers({ page: 1, search: talentFilterState.search });
            setTalentFilterState(prev => ({ ...prev, page: 1 }));
        }, 800);
        return () => clearTimeout(talentSearchTimer.current);
    }, [talentDialogOpen, talentFilterState.search, fetchTalentUsers, isPartialEmailSearch]);

    // Notify users and close dialog
    const handleNotifyTalentUsers = async () => {
        setNotifyLoading(true);
        try {
            const response = await customerServices.verifyTalentPlatfromUser(id);
            if (!response.status) {
                notify('error', response?.message);
            } else {
                notify('success', response?.message || 'Talent course completion users verified successfully');
                setTalentDialogOpen(false);
            }
        } catch (error) {
            notify('error', error?.message || 'Failed to verify Talent Course Completion users');
        }
        setNotifyLoading(false);
    };

    return (
        <>
            {initialLoading ? (
                <AppLoader minHeight={280} />
            ) : (
                <>
                    <section className={`${customerClasses.section} ${customerClasses.formFields}`}>
                        <div className={customerClasses.sectionHeader}>
                            <Typography component="h3" className={customerClasses.sectionTitle}>
                                Organisation information
                            </Typography>
                            <Typography className={customerClasses.sectionDescription}>
                                The customer account details used across projects, users and licence records.
                            </Typography>
                        </div>
                        <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label={fieldLabel('name')}
                                name="name"
                                value={formState.name}
                                onChange={handleInputChange}
                                {...errorProps('name')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <SectorField
                                label={fieldLabel('sector')}
                                value={formState.sector}
                                onChange={value => handleInputChange(value, 'sector')}
                                {...errorProps('sector')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                size="small"
                                label={fieldLabel('email')}
                                name="email"
                                type="email"
                                value={formState.email}
                                onChange={handleInputChange}
                                disabled={!!id}
                                {...errorProps('email')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <AddressAutocomplete
                                label={fieldLabel('address')}
                                value={formState.address}
                                onChange={value => handleInputChange(value, 'address')}
                                onPlaceSelected={handlePlaceSelected}
                                {...errorProps('address')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                freeSolo
                                inputValue={formState.country || ''}
                                options={countryList || []}
                                getOptionLabel={option => option || ''}
                                autoHighlight
                                onChange={(event, newValue, reason) => {
                                    const raw = newValue || '';
                                    // On blur/commit, snap case-insensitive matches to the canonical
                                    // option (e.g. "south africa" -> "South Africa") so the value is
                                    // recognised everywhere downstream that compares against the list.
                                    const normalized = (reason === 'blur' || reason === 'create-option')
                                        ? normalizeToOption(raw, countryList || [])
                                        : raw;
                                    handleCountryChange(normalized);
                                }}
                                onInputChange={(event, newValue, reason) => {
                                    if (reason === 'input' || reason === 'clear') handleCountryChange(newValue || '');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        label={fieldLabel('country')}
                                        {...errorProps('country')}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Autocomplete
                                multiple
                                freeSolo
                                disableCloseOnSelect
                                value={customerProvinces(formState)}
                                options={withCurrentOptions(provinceOptions(formState.country), customerProvinces(formState))}
                                getOptionLabel={option => option || ''}
                                autoHighlight
                                onChange={(event, values) => handleProvincesChange(values)}
                                renderOption={(option, { selected }) => (
                                    <>
                                        <Checkbox color="primary" checked={selected} style={{ marginRight: 8 }} />
                                        {option}
                                    </>
                                )}
                                renderTags={(values, getTagProps) => values.map((option, index) => (
                                    <Chip size="small" label={option} {...getTagProps({ index })} />
                                ))}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        size="small"
                                        label={fieldLabel('province')}
                                        placeholder={customerProvinces(formState).length ? '' : 'Select one or more'}
                                        {...errorProps('province')}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <OutlinedSelect
                                val={formState.partner}
                                name="partner"
                                label={fieldLabel('partner')}
                                variant="outlined"
                                handleChange={(evt) => handleInputChange(evt)}
                                styleOverrides={{ width: '100%', marginTop: 0 }}
                                options={accountList}
                                {...errorProps('partner')}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <PhoneInputField
                                label={fieldLabel('contact_no')}
                                handleChange={(newValue) => handleInputChange(newValue, 'contact_no')}
                                value={formState.contact_no}
                                {...errorProps('contact_no')}
                            />
                        </Grid>
                        </Grid>
                    </section>
                    <section className={`${customerClasses.section} ${customerClasses.sectionDivider} ${customerClasses.formFields}`}>
                        <div className={customerClasses.sectionHeader}>
                            <Typography component="h3" className={customerClasses.sectionTitle}>
                                Platform configuration
                            </Typography>
                            <Typography className={customerClasses.sectionDescription}>
                                Configure how the customer appears and connects to the Deviare platform.
                            </Typography>
                        </div>
                    {formState.partner && formState.partner !== 'enterprise_customer' && (
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    label={fieldLabel('branch')}
                                    name="branch"
                                    value={formState.branch}
                                    onChange={handleInputChange}
                                    {...errorProps('branch')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    label={fieldLabel('link')}
                                    name="link"
                                    value={formState.link}
                                    onChange={handleInputChange}
                                    {...errorProps('link')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    label={fieldLabel('api_key')}
                                    name="api_key"
                                    value={formState.api_key}
                                    onChange={handleInputChange}
                                    {...errorProps('api_key')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Autocomplete
                                    id="tags-outlined"
                                    value={formState.timezone}
                                    name="timezone"
                                    options={timezone}
                                    getOptionLabel={option => option.name}
                                    onChange={(event, newValue) => {
                                        setFormState({ ...formState, timezone: newValue });
                                    }}
                                    style={{ width: '100%' }}
                                    limitTags={2}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            size="small"
                                            label="TimeZone"
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    )}
                    <Grid container spacing={3}>
                        {formState.partner && formState.partner !== 'enterprise_customer' && (
                            <Grid item xs={12} md={6}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    label={fieldLabel('domain')}
                                    name="domain"
                                    value={formState.domain}
                                    onChange={handleInputChange}
                                    {...errorProps('domain')}
                                />
                                {formState.partner === 'strategy_partner' && (
                                    <div style={{ marginTop: 5, width: '100%', textAlign: 'right' }}>
                                        <label>.platform.digitalskillsonline.net</label>
                                    </div>
                                )}
                                {formState.partner === 'reseller_partner' && (
                                    <div style={{ marginTop: 5, width: '100%', textAlign: 'right' }}>
                                        <label>.partner.deviare.co.za</label>
                                    </div>
                                )}
                            </Grid>
                        )}
                        <Grid item xs={12} md={6} className={customerClasses.logoTalentRow}>
                            <div className={customerClasses.logoField}>
                                <span className={customerClasses.logoLabel} style={fieldErrors.logo ? { color: '#dc2626' } : undefined}>{fieldLabel('logo')}</span>
                                <div className={customerClasses.logoActions}>
                                    <input
                                        hidden
                                        id="customer-logo-input"
                                        type="file"
                                        name="BulkTemplate"
                                        accept="image/jpeg,image/jpg,image/png"
                                        onChange={handleUploadImage}
                                    />
                                    <label htmlFor="customer-logo-input">
                                        <Button
                                            component="span"
                                            variant="outlined"
                                            className={customerClasses.uploadButton}
                                            startIcon={<CloudUploadOutlinedIcon fontSize="small" />}
                                        >
                                            Choose logo
                                        </Button>
                                    </label>
                                    <span className={`${customerClasses.uploadHint}${fieldErrors.logo ? ' Mui-error' : ''}`} style={fieldErrors.logo ? { color: '#dc2626' } : undefined}>
                                        {fieldErrors.logo || (formState.logo ? 'Logo selected' : 'JPEG or PNG')}
                                    </span>
                                    {formState.logo && (
                                        <img
                                            loading="lazy"
                                            decoding="async"
                                            src={formState.logo}
                                            alt="Customer logo preview"
                                            className={customerClasses.logoPreview}
                                        />
                                    )}
                                </div>
                            </div>
                            {/* Talent Platform Access toggle — re-enable when needed
                            <FormControlLabel
                                className={customerClasses.talentToggle}
                                control={
                                    <Switch
                                        checked={!!formState.talent_access}
                                        onChange={handleToggleTalentAccess}
                                        disabled={talentToggleSaving || submitLoading}
                                        color="primary"
                                        name="talent_access"
                                    />
                                }
                                label="Talent Platform Access"
                                labelPlacement="end"
                            />
                            */}
                            {/* Fetch user completion list — re-enable when needed
                            {id && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={customerClasses.fetchButton}
                                    onClick={handleOpenTalentDialog}
                                    disabled={talentLoading}
                                >
                                    {talentLoading ? (
                                        <CircularProgress size={18} className={classes.buttonProgress} />
                                    ) : 'Fetch user completion list'}
                                </Button>
                            )}
                            */}
                        </Grid>
                    </Grid>
                    </section>
                    {formState.partner === 'strategy_partner' &&
                        <section className={`${customerClasses.section} ${customerClasses.sectionDivider} ${customerClasses.formFields}`}>
                            <div className={customerClasses.sectionHeader}>
                                <Typography component="h3" className={customerClasses.sectionTitle}>
                                    Email delivery
                                </Typography>
                                <Typography className={customerClasses.sectionDescription}>
                                    Use the customer's mail server only when platform emails must come from their domain.
                                </Typography>
                            </div>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={2}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox
                                                onChange={handleChangeSMTP}
                                                checked={showSMTP}
                                                name="smtp" />
                                            }
                                            label="SMTP Settings"
                                        />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                            {showSMTP && (
                                <React.Fragment>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="SMTP Server"
                                                name="email_host"
                                                value={formState.email_host}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="Port"
                                                name="port"
                                                value={formState.port}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="Email Account"
                                                name="from"
                                                value={formState.from}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="Mail Subject"
                                                name="email_subject_prifix"
                                                value={formState.email_subject_prifix}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <FormGroup style={{ margin: "10px 0" }}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={formState.secure_connection ? true : false} onChange={() => handleChangeCheckItem('secure_connection')} name="secure_connection" />}
                                                    label="Use Secure Connection"
                                                />
                                                <FormControlLabel
                                                    control={<Checkbox checked={formState.use_authentication ? true : false} onChange={() => handleChangeCheckItem('use_authentication')} name="use_authentication" />}
                                                    label="Use Authentication"
                                                />
                                            </FormGroup>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="Login"
                                                name="email_host_user"
                                                value={formState.email_host_user}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                label="Password"
                                                name="email_host_password"
                                                type="password"
                                                value={formState.email_host_password}
                                                onChange={handleInputChange}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={5}>
                                        <Grid item xs={12} sm={4}>
                                            <Button
                                                type={"button"}
                                                onClick={evt => setSendTestMailOpen(true)}
                                                variant="contained"
                                                color="primary"
                                                style={{ borderRadius: '5px' }}
                                            >
                                                Send Test Email
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            )}
                        </section>
                    }

                    <SendTestEmailModal
                        open={sendTestMailOpen}
                        handleClose={evt => setSendTestMailOpen(false)}
                        handleSubmit={handleSendEmailSubmit}
                        loading={sendTestEmailLoading}
                    />
                    <Dialog
                        open={talentDialogOpen}
                        onClose={() => setTalentDialogOpen(false)}
                        maxWidth="lg"
                        fullWidth
                        BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.2)' } }}
                    >
                        <DialogTitle>Talent Platform Users & Courses</DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2} style={{ marginBottom: 12 }}>
                                <Grid item xs={12} sm={8} md={6}>
                                    <SearchBoxInput
                                        value={talentFilterState.search}
                                        handleChange={(evt) => setTalentFilterState({ ...talentFilterState, search: evt.target.value })}
                                        handleSearch={handleTalentSearch}
                                        placeholder="Search by email and course"
                                        styleOverrides={{ minWidth: '100%' }}
                                    />
                                    {isPartialEmailSearch && (
                                        <Typography variant="caption" color="error">
                                            Please enter a complete email address to search by email.
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <TableContainer className={customerClasses.tableContainer}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={customerClasses.headerCell}>User Name</TableCell>
                                            <TableCell className={customerClasses.headerCell}>Email</TableCell>
                                            <TableCell className={customerClasses.headerCell}>Courses</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {talentLoading ? (
                                            <TableRow>
                                                <TableCell colSpan={3} className={customerClasses.tableLoadingCell}>
                                                    <ContentLoading columns={3} />
                                                </TableCell>
                                            </TableRow>
                                        ) : talentUsers.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={3} className={customerClasses.tableLoadingCell}>
                                                    <Typography>Record not found.</Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            talentUsers.map((user, idx) => (
                                                <TableRow key={idx} className={customerClasses.bodyRow}>
                                                    <TableCell className={customerClasses.bodyCell}>
                                                        {user.full_name || user.userName}
                                                    </TableCell>
                                                    <TableCell className={customerClasses.bodyCell}>{user.email}</TableCell>
                                                    <TableCell className={customerClasses.bodyCell}>
                                                        {(user.courses || []).map((course, cidx) => (
                                                            <div key={cidx} style={{ marginBottom: 8 }}>
                                                                <strong>{course.course_title}</strong><br />
                                                                Status: {course.certification_status}<br />
                                                                Completion: {course.completion_date}<br />
                                                                Email Sent: {course.is_email_sent ? 'Yes' : 'No'}
                                                            </div>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Grid container style={{ marginTop: 16 }}>
                                {talentPagination && (
                                    <Pagination
                                        onChange={handleTalentPageChange}
                                        style={{ margin: '0 auto' }}
                                        page={parseInt(talentFilterState.page || 1, 10)}
                                        count={parseInt(talentPagination?.total_pages || 0, 10)}
                                        variant="outlined"
                                        shape="rounded"
                                        siblingCount={0}
                                    />
                                )}
                            </Grid>
                        </DialogContent>
                        <DialogActions className={customerClasses.dialogActions}>
                            <div className={`${onBorningClasses.buttons} ${customerClasses.dialogActionButtons}`}>
                                <Button onClick={() => setTalentDialogOpen(false)} variant="outlined" color="default" className={onBorningClasses.cancelBtn} disabled={notifyLoading}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleNotifyTalentUsers}
                                    color="primary"
                                    variant="contained"
                                    className={onBorningClasses.button}
                                    disabled={notifyLoading || talentUsers.length === 0}
                                >
                                    {notifyLoading ? <CircularProgress size={18} /> : 'Notify & Close'}
                                </Button>
                            </div>
                        </DialogActions>
                    </Dialog>
                    <div className={customerClasses.actionBar}>
                        {!id && (
                            <Button
                                type="button"
                                onClick={handleCancel}
                                variant="outlined"
                                color="default"
                                className={customerClasses.cancelAction}
                            >
                                Cancel onboarding
                            </Button>
                        )}
                        <div className={customerClasses.actionButtons}>
                            {activeStep !== 0 && (
                                <Button
                                    onClick={handleBack}
                                    variant="outlined"
                                    color="default"
                                    className={onBorningClasses.cancelBtn}>
                                    Back
                                </Button>
                            )}
                            <Button
                                type={"button"}
                                onClick={formValidationCheck}
                                variant="contained"
                                color="primary"
                                disabled={submitLoading || initialLoading}
                                className={customerClasses.continueAction}
                                endIcon={submitLoading ? null : <ArrowForwardIcon fontSize="small" />}
                            >
                                {submitLoading ? (
                                    <CircularProgress
                                        size={18}
                                        className={classes.buttonProgress}
                                    />
                                ) : 'Continue to Licences'}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Customer;
